import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import TableCell from './TableCell'

const styles = theme => ({
  tableSubItem: {
    paddingLeft: '13px'
  }
})

const TableRow = React.memo(props => {
  const { classes, functionality, onChange, readOnly } = props
  const className = /conteudos-|preCadastros-/.test(functionality.alias) && classes.tableSubItem

  return (
    <tr>
      <td className={className}>{functionality.nome || '--'}</td>
      {['ler', 'editar', 'remover'].map((type, key) => {
        return (
          <TableCell
            key={key}
            type={type}
            functionality={functionality}
            checked={!!functionality[type]}
            onChange={onChange(functionality, type)}
            readOnly={readOnly}
          />
        )
      })}
    </tr>
  )
})

export default withStyles(styles)(TableRow)



// WEBPACK FOOTER //
// ./src/components/PermissionsTable/TableRow.js